/**
 * @generated SignedSource<<0a86eb8593e11db63a36861c15a491be>>
 * @relayHash 9ad633d8ff58cbaa3812ba5a2ed2e90d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2c92ad1e080d454d2e9ab39c70b2b02f2f837515049c5b626ce9e50b0df0fb06

import type { ConcreteRequest } from 'relay-runtime';
export type ViewPageConfluenceRecordCompanionTipScrollSignalMutation$variables = {
  cloudId: string;
  pageId: string;
};
export type ViewPageConfluenceRecordCompanionTipScrollSignalMutation$data = {
  readonly confluence_recordCompanionTipScrollSignal: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null;
    } | null> | null;
    readonly success: boolean | null;
  } | null;
};
export type ViewPageConfluenceRecordCompanionTipScrollSignalMutation = {
  response: ViewPageConfluenceRecordCompanionTipScrollSignalMutation$data;
  variables: ViewPageConfluenceRecordCompanionTipScrollSignalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
      }
    ],
    "concreteType": "ConfluenceRecordCompanionTipScrollSignalPayload",
    "kind": "LinkedField",
    "name": "confluence_recordCompanionTipScrollSignal",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ViewPageConfluenceRecordCompanionTipScrollSignalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewPageConfluenceRecordCompanionTipScrollSignalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9ad633d8ff58cbaa3812ba5a2ed2e90d",
    "id": "2c92ad1e080d454d2e9ab39c70b2b02f2f837515049c5b626ce9e50b0df0fb06",
    "metadata": {},
    "name": "ViewPageConfluenceRecordCompanionTipScrollSignalMutation",
    "operationKind": "mutation",
    "text": "mutation ViewPageConfluenceRecordCompanionTipScrollSignalMutation($cloudId:ID!,$pageId:ID!){confluence_recordCompanionTipScrollSignal(cloudId:$cloudId,pageId:$pageId){success,errors{message}}}"
  }
};
})();

(node as any).hash = "834a9fbfb789a14ba2f80fa10e53afeb";

export default node;
